"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/source/types");
var initialState = false;
function dragSource() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.BROADCAST_DRAG_SOURCE) {
    return action.payload;
  }
  return state;
}
var _default = exports["default"] = dragSource;